"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.editEvaluationTemplate = exports.parsePopulationFromStorage = exports.parseFiles = exports.parseFileInfo = void 0;
/* eslint-disable no-undef */
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation = __importStar(require("@cck/common/dist/data/Evaluation"));
var FileUtils_1 = require("@cck/common/dist/utils/FileUtils");
var StringUtils_1 = require("@cck/common/dist/utils/StringUtils");
var PopulationFileReader_1 = require("@cck/js/src/PopulationFileReader");
var jszip_1 = __importDefault(require("jszip"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var xlsx_1 = __importDefault(require("xlsx"));
var ControlManager_1 = require("../rcm/ControlManager");
var StorageManager_1 = require("../storage/StorageManager");
var DesignConfig = __importStar(require("./DesignExcelConfigs"));
var EvaluationUtils = __importStar(require("./EvaluationUtils"));
var OperationConfig = __importStar(require("./OperationExcelConfigs"));
function parseExcelCell(workSheet, cellId) {
    try {
        var value = void 0;
        if (workSheet[cellId].t === 'd') {
            value = workSheet[cellId].w;
        }
        else {
            value = workSheet[cellId].v.toString().trim();
        }
        // 예외처리: 엑셀에서 음영처리한 부분의 다음과 같은 내부 값이 들어온다.
        // <phoneticPr fontId="3" type="noConversion"/>
        if (value[0] === '<' && value.slice(-1) === '>') {
            return '';
        }
        return value;
    }
    catch (_a) {
        return '';
    }
}
function parseExcelCellToDateStr(workSheet, cellId) {
    var value = parseExcelCell(workSheet, cellId);
    var date = (0, moment_1.default)(new Date(value));
    if (!date.isValid()) {
        date = (0, moment_1.default)();
    }
    return date.format('YYYY-MM-DD');
}
function parseExcelCellToNumber(workSheet, cellId) {
    var value = lodash_1.default.parseInt(parseExcelCell(workSheet, cellId));
    return isNaN(value) ? 0 : value;
}
function parseExcelCellToResult(workSheet, cellId) {
    var value = parseExcelCell(workSheet, cellId);
    return value === 'Effective' ? Evaluation.Result.effective : Evaluation.Result.ineffective;
}
function parseTableContent(workSheet, cellId, rows, columns, table, exceptionStr, exceptions) {
    table.rowCountExceptHeader = rows;
    table.columnCountIncludeNumbering = columns;
    var colIdx = cellId.charCodeAt(0) - 'A'.charCodeAt(0) + 1;
    var rowNumberStr = cellId.substring(1);
    var rowIdx = lodash_1.default.parseInt(rowNumberStr);
    if (lodash_1.default.isEmpty(table.headerRow)) {
        for (var i = 0; i < columns; ++i) {
            var cellKey = (0, StringUtils_1.toLetters)(colIdx + i) + rowNumberStr;
            var value = parseExcelCell(workSheet, cellKey);
            if (!value) {
                exceptions.push("".concat(exceptionStr, " \uD5E4\uB354\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."));
                return;
            }
            table.headerRow.push(value);
        }
        rowIdx += 1;
    }
    for (var i = 0; i < rows; ++i) {
        var values = {};
        for (var j = 0; j < columns; ++j) {
            var cellKey = (0, StringUtils_1.toLetters)(colIdx + j) + String(rowIdx + i);
            var rowKey = table.headerRow[j];
            values[rowKey] = parseExcelCell(workSheet, cellKey);
        }
        table.rowObjectList.push(values);
    }
}
function parseOperationRecord(file) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            /*
            운영평가 보고서 엑셀파일을 파싱한다.
            업로드를 위한 파싱은 지정된 위치의 값만 읽으면 된다.
          
            각 값들의 위치는 바뀌지 않기 때문에 다음 객체의 정보를 바탕으로 한다.
          
            TODO: number 랑 id 랑 같은지 체크필요
            */
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    // eslint-disable-next-line no-undef
                    var fileReader = new FileReader();
                    fileReader.onloadend = function (evt) {
                        var _a;
                        if (!((_a = evt === null || evt === void 0 ? void 0 : evt.target) === null || _a === void 0 ? void 0 : _a.result)) {
                            reject(new Error('Failed read file'));
                            return;
                        }
                        var targetExcelFile = evt.target.result;
                        var excelData = xlsx_1.default.read(targetExcelFile, {
                            type: 'binary',
                            sheetStubs: true,
                            cellDates: true,
                            dateNF: 'yyyy-mm-dd'
                        });
                        var newFile = __assign(__assign({}, file), { state: BaseFile_1.FileState.OK, excelData: undefined });
                        var evaluationData = {
                            type: Evaluation.Type.Operation,
                            updateTime: '',
                            createDate: '',
                            controlId: '',
                            resultState: Evaluation.ResultState.Normal,
                            executor: '',
                            populationDescription: '',
                            populationCount: '',
                            populationCompleteness: '',
                            samplingMethod: '',
                            controlException: '',
                            samplingCount: 0,
                            populationTableColumnCount: 0,
                            samplingAttributeCount: 0,
                            samplingResult: {
                                headerRow: [],
                                columnCountIncludeNumbering: 0,
                                rowCountExceptHeader: 0,
                                rowObjectList: []
                            },
                            attributeContents: {
                                headerRow: [],
                                columnCountIncludeNumbering: 0,
                                rowCountExceptHeader: 0,
                                rowObjectList: []
                            },
                            testContents: {
                                headerRow: [],
                                columnCountIncludeNumbering: 0,
                                rowCountExceptHeader: 0,
                                rowObjectList: []
                            },
                            validCount: '',
                            invalidCount: '',
                            testResult: ''
                        };
                        var excelResultException = [];
                        // Overview
                        {
                            var name_1 = 'Overview';
                            var workSheet = excelData.Sheets[name_1];
                            var config = OperationConfig.PARSING_MAP[name_1];
                            evaluationData.executor = parseExcelCell(workSheet, config.executor.pos);
                            evaluationData.createDate = parseExcelCellToDateStr(workSheet, config.createDate.pos);
                            evaluationData.populationCount = parseExcelCell(workSheet, config.populationCount.pos);
                            evaluationData.samplingCount = parseExcelCellToNumber(workSheet, config.samplingCount.pos);
                            evaluationData.validCount = parseExcelCell(workSheet, config.validCount.pos);
                            evaluationData.invalidCount = parseExcelCell(workSheet, config.invalidCount.pos);
                            evaluationData.testResult = parseExcelCell(workSheet, config.testResult.pos);
                            // 특이사항 - 운영 테스트결과
                            // 특이사항 - 비유효 항목수
                            var invalidCount = lodash_1.default.parseInt(evaluationData.invalidCount);
                            if (evaluationData.testResult === '예외사항 발생' ||
                                (!isNaN(invalidCount) && invalidCount > 0)) {
                                evaluationData.resultState = Evaluation.ResultState.Defect;
                            }
                        }
                        // 모집단 및 샘플링
                        {
                            var name_2 = '모집단 및 샘플링';
                            var workSheet = excelData.Sheets[name_2];
                            var config = OperationConfig.PARSING_MAP[name_2];
                            evaluationData.populationDescription = parseExcelCell(workSheet, config.populationDescription.pos);
                            evaluationData.populationCompleteness = parseExcelCell(workSheet, config.populationCompleteness.pos);
                            evaluationData.samplingMethod = parseExcelCell(workSheet, config.samplingMethod.pos);
                            evaluationData.populationTableColumnCount = parseExcelCellToNumber(workSheet, config.populationTableColumnCount.pos);
                            if (evaluationData.samplingCount > 0 && evaluationData.populationTableColumnCount > 0) {
                                parseTableContent(workSheet, config.samplingResult.pos, evaluationData.samplingCount, evaluationData.populationTableColumnCount + 1, evaluationData.samplingResult, config.samplingResult.korName, excelResultException);
                            }
                            else {
                                excelResultException.push(config.samplingResult.korName);
                            }
                        }
                        // 운영평가 수행
                        {
                            var name_3 = '운영평가 수행';
                            var workSheet = excelData.Sheets[name_3];
                            var config = OperationConfig.PARSING_MAP[name_3];
                            evaluationData.samplingAttributeCount = parseExcelCellToNumber(workSheet, config.samplingAttributeCount.pos);
                            evaluationData.attributeContents.headerRow = [
                                'Attribute',
                                '테스트 상세내용',
                                '예외사항 정의'
                            ];
                            if (evaluationData.samplingAttributeCount > 0) {
                                parseTableContent(workSheet, config.attributeContents.pos, evaluationData.samplingAttributeCount, 3, evaluationData.attributeContents, config.attributeContents.korName, excelResultException);
                            }
                            else {
                                excelResultException.push(config.attributeContents.korName);
                            }
                            if (evaluationData.attributeContents.rowCountExceptHeader > 0 &&
                                evaluationData.samplingCount > 0 &&
                                evaluationData.samplingAttributeCount > 0) {
                                var rowIdx = lodash_1.default.parseInt(config.attributeContents.pos.substring(1)) +
                                    evaluationData.attributeContents.rowCountExceptHeader;
                                while (true) {
                                    rowIdx += 1;
                                    var cellKey = config.testContents.pos + String(rowIdx);
                                    if (typeof workSheet[cellKey] === 'undefined' || workSheet[cellKey].t === 'z') {
                                        continue;
                                    }
                                    var value = parseExcelCell(workSheet, cellKey);
                                    if (value === config.testContents.korName) {
                                        break;
                                    }
                                }
                                evaluationData.testContents.headerRow.push('No');
                                for (var i = 0; i < evaluationData.samplingAttributeCount; ++i) {
                                    var baseName = 'Attribute_';
                                    evaluationData.testContents.headerRow.push(baseName + String(i + 1) + '/결과');
                                    evaluationData.testContents.headerRow.push(baseName + String(i + 1) + '/상세');
                                }
                                evaluationData.testContents.headerRow.push('테스트 결과');
                                evaluationData.testContents.headerRow.push('증빙자료 Ref');
                                rowIdx += config.testContents.nth_from_above;
                                if (evaluationData.samplingCount > 0 && evaluationData.samplingAttributeCount > 0) {
                                    parseTableContent(workSheet, config.testContents.pos + String(rowIdx), evaluationData.samplingCount, evaluationData.samplingAttributeCount * 2 + 3, evaluationData.testContents, config.testContents.korName, excelResultException);
                                }
                                rowIdx += evaluationData.samplingCount + config.controlException.nth_from_above;
                                evaluationData.controlException = parseExcelCell(workSheet, config.controlException + String(rowIdx));
                            }
                        }
                        // 최종 예외처리
                        if (excelResultException.length > 0) {
                            newFile.state = BaseFile_1.FileState.PARSING_ERROR;
                        }
                        newFile.excelData = evaluationData;
                        newFile.excelException = excelResultException;
                        resolve(newFile);
                    };
                    fileReader.onerror = reject;
                    if (!file.file) {
                        return reject(new Error('Empty file'));
                    }
                    fileReader.readAsBinaryString(file.file);
                })];
        });
    });
}
function parseDesignRecord(file) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // NOTE: 220528. 대유플러스 사용하지 않음.
            /*
            설계평가 보고서 엑셀파일을 파싱한다.
            업로드를 위한 파싱은 지정된 위치의 값만 읽으면 된다.
            */
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    // eslint-disable-next-line no-undef
                    var fileReader = new FileReader();
                    fileReader.onloadend = function (evt) {
                        var _a;
                        if (!((_a = evt === null || evt === void 0 ? void 0 : evt.target) === null || _a === void 0 ? void 0 : _a.result)) {
                            reject(new Error('Failed read file'));
                            return;
                        }
                        var targetExcelFile = evt.target.result;
                        var excelData = xlsx_1.default.read(targetExcelFile, {
                            type: 'binary',
                            sheetStubs: true,
                            cellDates: true,
                            dateNF: 'yyyy-mm-dd'
                        });
                        var newFile = __assign(__assign({}, file), { state: BaseFile_1.FileState.OK, excelData: undefined });
                        var name = '설계평가';
                        var workSheet = excelData.Sheets[name];
                        var config = DesignConfig.PARSING_MAP[name];
                        newFile.excelData = {
                            type: Evaluation.Type.Design,
                            updateTime: '',
                            createDate: parseExcelCellToDateStr(workSheet, config.createDate.pos),
                            controlId: '',
                            resultState: parseExcelCell(workSheet, config.result.pos) === 'Effective'
                                ? Evaluation.ResultState.Normal
                                : Evaluation.ResultState.Defect,
                            ownerAssessment: '',
                            judgementLevel: Evaluation.JudgementLevel.low,
                            riskAssessmentBasis: '',
                            considerations: lodash_1.default.compact(lodash_1.default.map(lodash_1.default.zip(config.considerationContents, config.considerationResults), function (value) {
                                var contentPos = value[0], resultPos = value[1];
                                if (contentPos && resultPos) {
                                    return {
                                        content: parseExcelCell(workSheet, contentPos.pos),
                                        result: parseExcelCellToResult(workSheet, resultPos.pos)
                                    };
                                }
                                return undefined;
                            })),
                            baselineReference: parseExcelCell(workSheet, config.baselineReference.pos),
                            procedureContent: ''
                        };
                        resolve(newFile);
                    };
                    fileReader.onerror = reject;
                    if (!file.file) {
                        return reject(new Error('Empty file'));
                    }
                    fileReader.readAsBinaryString(file.file);
                })];
        });
    });
}
function parseRecord(evalType, file) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // TODO
            return [2 /*return*/, evalType === Evaluation.Type.Operation
                    ? parseOperationRecord(file)
                    : parseDesignRecord(file)];
        });
    });
}
function parseFileInfoInner(evaluationType, files, targetEvaluationName) {
    return lodash_1.default.map(files, function (file) {
        var nameWithoutExtension = file.name.slice(0, file.name.lastIndexOf('.'));
        var state = BaseFile_1.FileState.OK;
        var evaluationName = '';
        var controlId = '';
        var type = BaseFile_1.FileType.Extra;
        try {
            var infos = EvaluationUtils.checkEvaluationName(nameWithoutExtension, targetEvaluationName);
            if (infos) {
                evaluationName = infos.evaluationName;
                controlId = infos.controlId;
                type = infos.fileType;
            }
            else {
                state = BaseFile_1.FileState.INVALID_STRUCTURE;
            }
            if (evaluationType === Evaluation.Type.Design && (infos === null || infos === void 0 ? void 0 : infos.fileType) !== BaseFile_1.FileType.Extra) {
                state = BaseFile_1.FileState.INVALID_STRUCTURE;
            }
        }
        catch (e) {
            console.log('Invalid file name ', e);
            state = BaseFile_1.FileState.INVALID_NAME;
        }
        // 모집단의 제한사항 검사 - 무조건 확장자는 xlsx
        var fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
        if (type === BaseFile_1.FileType.Population && fileExtension !== 'xlsx') {
            // 모집단의 경우 확장자가 xlsx 가 아니면 업로드 불가!
            state = BaseFile_1.FileState.INVALID_POPULATION_FILE_EXTENSION;
        }
        var dotResult = file.name.match(/\./g);
        if (dotResult && (dotResult.length == null || dotResult.length !== 1)) {
            // 21 상태 신규로 만듬 "확장자 표시 이외 "." 사용 금지"
            state = BaseFile_1.FileState.INVALID_DOT;
        }
        return {
            type: type,
            evaluationType: evaluationType,
            name: file.name,
            evaluationName: evaluationName,
            controlId: controlId,
            state: state,
            file: file,
            updateTime: '',
            updater: '',
            checked: false
        };
    });
}
function parseFileInfo(evaluationType, files, targetEvaluationName, targetControlId) {
    return lodash_1.default.map(parseFileInfoInner(evaluationType, files, targetEvaluationName), function (baseFile) {
        if (baseFile.state === BaseFile_1.FileState.OK) {
            if (baseFile.evaluationName !== targetEvaluationName) {
                baseFile.state = BaseFile_1.FileState.UNRELATED_OPERATION_EVAL;
            }
            else if (baseFile.controlId !== targetControlId) {
                baseFile.state = BaseFile_1.FileState.DIFFERENT_CONTROL_ID;
            }
        }
        return baseFile;
    });
}
exports.parseFileInfo = parseFileInfo;
function parseFiles(evalType, files, targetEvaluationName) {
    return __awaiter(this, void 0, void 0, function () {
        var _this = this;
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.all(lodash_1.default.map(parseFileInfoInner(evalType, files, targetEvaluationName), function (file) { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(file.type === BaseFile_1.FileType.Record && file.state === BaseFile_1.FileState.OK)) return [3 /*break*/, 2];
                                return [4 /*yield*/, parseRecord(evalType, file)];
                            case 1: return [2 /*return*/, _a.sent()];
                            case 2:
                                if (!(file.type === BaseFile_1.FileType.Population && file.state === BaseFile_1.FileState.OK)) return [3 /*break*/, 4];
                                return [4 /*yield*/, (0, PopulationFileReader_1.parsePopulationFile)(file)];
                            case 3: return [2 /*return*/, _a.sent()];
                            case 4: return [2 /*return*/, file];
                        }
                    });
                }); }))];
        });
    });
}
exports.parseFiles = parseFiles;
/**
 * 이미 업로드 된 모집단 파일을 가져와서 파싱한다. MAX_POPULATION_SIZE를 초과한 경우 파싱하지 않는다.
 * @param evaluationName
 * @param controlId
 * @param fileName
 * @param readPopulationFile
 */
function parsePopulationFromStorage(evaluationName, controlId, fileName, readPopulationFile) {
    return __awaiter(this, void 0, void 0, function () {
        var filePath, blob, blobToFile, newFileObject;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filePath = "/\uC6B4\uC601\uD3C9\uAC00/".concat(evaluationName, "/").concat(controlId, "/").concat(fileName);
                    return [4 /*yield*/, (0, StorageManager_1.downloadBlobFromPath)(filePath)];
                case 1:
                    blob = _a.sent();
                    blobToFile = new File([blob], fileName);
                    newFileObject = {
                        type: BaseFile_1.FileType.Population,
                        evaluationType: Evaluation.Type.Operation,
                        name: fileName,
                        evaluationName: evaluationName,
                        controlId: controlId,
                        state: BaseFile_1.FileState.OK,
                        file: blobToFile,
                        updateTime: '',
                        updater: '',
                        excelData: undefined,
                        checked: false
                    };
                    if (!newFileObject.file || (0, FileUtils_1.getFileSizeByMB)(newFileObject.file) >= FileUtils_1.MAX_POPULATION_SIZE) {
                        return [2 /*return*/, newFileObject];
                    }
                    return [4 /*yield*/, readPopulationFile(newFileObject)];
                case 2: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
exports.parsePopulationFromStorage = parsePopulationFromStorage;
function decodeXml(rawXmlData) {
    var stringDecoder = new TextDecoder('utf-8');
    var stringData = stringDecoder.decode(rawXmlData);
    var xmlParser = new DOMParser();
    var decodedXmlData = xmlParser.parseFromString(stringData, 'text/xml');
    return decodedXmlData;
}
function extractXml(blob) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var zip, loadZip, array8Data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    zip = new jszip_1.default();
                    return [4 /*yield*/, zip.loadAsync(blob)];
                case 1:
                    loadZip = _b.sent();
                    return [4 /*yield*/, ((_a = loadZip.file('xl/sharedStrings.xml')) === null || _a === void 0 ? void 0 : _a.async('uint8array'))];
                case 2:
                    array8Data = _b.sent();
                    if (!array8Data) {
                        return [2 /*return*/, Promise.reject(new Error('Failed to extract xml'))];
                    }
                    return [2 /*return*/, decodeXml(array8Data)];
            }
        });
    });
}
function encodeXml(xmlData) {
    var xmlString = new XMLSerializer().serializeToString(xmlData);
    var stringEncoder = new TextEncoder();
    var encodedXmlData = stringEncoder.encode(xmlString);
    return encodedXmlData;
}
function editOperationXml(controlId, control, xmlData) {
    return __awaiter(this, void 0, void 0, function () {
        var siElementList, parsingWriteMap, writeKeyList, i, content;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!control) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, ControlManager_1.get)(controlId)];
                case 1:
                    // CONTROL 의 데이터를 불러와서 이를 바탕으로 만들면 된다.
                    control = _a.sent();
                    _a.label = 2;
                case 2:
                    siElementList = xmlData.getElementsByTagName('si');
                    parsingWriteMap = lodash_1.default.cloneDeep(OperationConfig.PARSING_CONTROL_MAP);
                    writeKeyList = Object.keys(parsingWriteMap);
                    for (i = 0; i < siElementList.length; i++) {
                        content = siElementList[i].getElementsByTagName('t')[0].textContent;
                        if (content && writeKeyList.includes(content)) {
                            // 예외
                            if (content === 'Yes') {
                                parsingWriteMap.keyControl = i;
                                writeKeyList.push('keyControl');
                            }
                            else if (content === '일별수시') {
                                parsingWriteMap.period = i;
                                writeKeyList.push('period');
                            }
                            else if (content === '수동통제') {
                                parsingWriteMap.autoManual = i;
                                writeKeyList.push('autoManual');
                            }
                            else {
                                parsingWriteMap[content] = i;
                            }
                        }
                    }
                    // siElement 의 textContent 를 updateObject 의 값으로 변경
                    writeKeyList.forEach(function (key) {
                        var index = parsingWriteMap[key];
                        if (index !== -1) {
                            siElementList[index].getElementsByTagName('t')[0].textContent = lodash_1.default.get(control, key);
                        }
                    });
                    return [2 /*return*/, encodeXml(xmlData)];
            }
        });
    });
}
function mergeOperationExcel(blobData, xmlData, name) {
    return __awaiter(this, void 0, void 0, function () {
        var zip, loadZip, modifiedZip, newBlobData, newExcelFile;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    zip = new jszip_1.default();
                    return [4 /*yield*/, zip.loadAsync(blobData)];
                case 1:
                    loadZip = _a.sent();
                    return [4 /*yield*/, loadZip.file('xl/sharedStrings.xml', xmlData)];
                case 2:
                    modifiedZip = _a.sent();
                    return [4 /*yield*/, modifiedZip.generateAsync({ type: 'blob' })];
                case 3:
                    newBlobData = _a.sent();
                    newExcelFile = new File([newBlobData], name, {
                        type: 'application/vnd.ms-excel.sheet.macroEnabled.12'
                    });
                    return [2 /*return*/, newExcelFile];
            }
        });
    });
}
function editOperationTemplate(controlId, control, blobData) {
    return __awaiter(this, void 0, void 0, function () {
        var fileName, fileFullPath, xmlData, modifiedXmlData, final;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileName = "(\uC6B4\uC601\uD3C9\uAC00)(".concat(controlId, ")(\uC218\uD589\uC804Template).xlsm");
                    fileFullPath = "Template/\uC6B4\uC601\uD3C9\uAC00/".concat(fileName);
                    return [4 /*yield*/, extractXml(blobData)];
                case 1:
                    xmlData = _a.sent();
                    return [4 /*yield*/, editOperationXml(controlId, control, xmlData)];
                case 2:
                    modifiedXmlData = _a.sent();
                    return [4 /*yield*/, mergeOperationExcel(blobData, modifiedXmlData, fileName)];
                case 3:
                    final = _a.sent();
                    return [4 /*yield*/, (0, StorageManager_1.uploadFile)(fileFullPath, final)];
                case 4:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function editEvaluationTemplate(type, controlId, control, blobData) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(type === Evaluation.Type.Operation)) return [3 /*break*/, 2];
                    return [4 /*yield*/, editOperationTemplate(controlId, control, blobData)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
}
exports.editEvaluationTemplate = editEvaluationTemplate;
//# sourceMappingURL=ExcelParser.js.map